class VideoPlayer extends HTMLElement {
    constructor() {
        super();
        this.elements = {} // Initialize but don't populate here
    }
    
    // ⭐ Use connectedCallback to access child elements
    connectedCallback() {
        setTimeout(() => {
            
        this.elements = {
            button: this.querySelector('[js-five-senses-carousel="button"]'),
            video: this.querySelector('[js-video-player="video"]')
        };
        
        // 2. SAFE INITIALIZATION WITH NULL CHECKS
        if (this.elements.video) {
            this.elements.video.playbackRate = 1;
            this.elements.video.addEventListener("play", this.changeButton.bind(this));
            this.elements.video.addEventListener("pause", this.changeButton.bind(this));
            // Add 'ended' listener back if SwiperSlider needs it.
            this.elements.video.addEventListener("ended", this.onVideoEnded.bind(this));
        }
        if (this.elements.button) {
            this.elements.button.addEventListener("click", this.playVideo.bind(this));
        }
      }, 1000);

    }
    playVideo() {
        var _this = this;
        if (document.querySelectorAll('video').length) {
            document.querySelectorAll('video').forEach(function(vid) {
                if (vid != _this.elements.video) {
                    vid.pause();
                }
            });
        }
        if (this.elements.video.paused) {
            this.elements.video.play();
        } else {
            this.elements.video.pause();
        }
    }
    changeButton() {
        if (this.elements.video.paused) {
            this.elements.button.classList.remove('is-active');
        } else {
            this.elements.button.classList.add('is-active');
        }
    }
    onVideoEnded() {
        // Find the parent swiper-slider element
        const swiperSlider = this.closest('swiper-slider');
        if (swiperSlider && swiperSlider.isSequentialPlayback) {
            // Let the SwiperSlider handle the next video
            // const currentIndex = Array.from(this.elements.video.parentElement.parentElement.children).indexOf(this.elements.video.parentElement);
            // swiperSlider.playNextVideo(currentIndex);

            const slideElement = this.closest('[js-five-senses-carousel="cell"]'); // This is the swiper-slide element
            const slidesWrapper = slideElement ? slideElement.parentElement : null;
            if (slideElement && slidesWrapper) {
                const currentIndex = Array.from(slidesWrapper.children).indexOf(slideElement);
                setTimeout(() => {
                    this.elements.video.load();
                    swiperSlider.playNextVideo(currentIndex);
                }, 150);
            }
        }
    }
    // Method to force play this video
    forcePlay() {
        this.elements.video.currentTime = 0;
        this.elements.video.play().catch(error => {
            console.log('Force play failed:', error);
        });
    }
    // Method to pause this video
    forcePause() {
        this.elements.video.pause();
    }
}
customElements.define("video-player", VideoPlayer);
class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        // this.element = this.querySelector('[js-five-senses-carousel="container"]');
        // this.navigation = this.querySelector('[js-five-senses-carousel="navigation"]');
        // this.pagination = this.querySelector('[js-five-senses-carousel="pagination"]');
        this.currentVideoIndex = 0;
        this.videos = [];
        this.isSequentialPlayback = true; // Flag to control sequential playback
        var _this = this;

      console.log(typeof Swiper)
        // if(typeof Swiper == 'function') {
        //     this.initSlider()  
        // } else {
        //     // Create a script element
        //     const script = document.createElement('script');

        //     // Set the source to the Swiper CDN
        //     script.src = "https://cdn.jsdelivr.net/npm/swiper@6/swiper-bundle.min.js";

        //     // Optional: Set the type attribute
        //     script.type = "text/javascript";

        //     // Optional: Add an onload callback to initialize Swiper after the script is loaded
        //     script.onload = () => {
        //         this.initSlider(); // Call initSlider once Swiper is loaded
        //     };

        //     // Append the script to the head or body
        //     document.head.appendChild(script); // Or document.body.appendChild(script);
        // }
    }

    connectedCallback() {
        setTimeout(() => {
            
        // 🚀 THIS IS THE FIX: Query the children here.
        this.element = this.querySelector('[js-five-senses-carousel="container"]');
        this.navigation = this.querySelector('[js-five-senses-carousel="navigation"]');
        this.pagination = this.querySelector('[js-five-senses-carousel="pagination"]');
        if (!this.element) {
             console.error('Swiper container element not found inside <swiper-slider>');
             return;
        }

        if(typeof Swiper == 'function') {
            this.initSlider()  
        } else {
            // Create a script element
            const script = document.createElement('script');

            // Set the source to the Swiper CDN
            script.src = "https://cdn.jsdelivr.net/npm/swiper@6/swiper-bundle.min.js";

            // Optional: Set the type attribute
            script.type = "text/javascript";

            // Optional: Add an onload callback to initialize Swiper after the script is loaded
            script.onload = () => {
                this.initSlider(); // Call initSlider once Swiper is loaded
            };

            // Append the script to the head or body
            document.head.appendChild(script); // Or document.body.appendChild(script);
        }
        }, 100);

    }

    initSlider() {
      window.init = false;
        const nextEl = this.navigation?.querySelector('.swiper-button-next') || '.swiper-button-next';
        const prevEl = this.navigation?.querySelector('.swiper-button-prev') || '.swiper-button-prev';

        var length = this.querySelectorAll('[js-five-senses-carousel="cell"]').length;
        const oldOptions = {
            a11y: { enabled: !0 },
            aria: !0,
            centeredSlides: !0,
            keyboard: { enabled: !0, onlyInViewport: !0 },
            mousewheel: { forceToAxis: !0 },
            loop: false,
            loopedSlides: length,
            pagination: { el: this.pagination, type: "bullets", clickable: !0 },
            preventInteractionOnTransition: !0,
            slidesPerView: 1.5,
            spaceBetween: 16,
            watchSlidesVisibility: !0,
            navigation: { nextEl: nextEl, prevEl: prevEl },
            on: {
                slideChange: () => {
                    if (this.swiperInstance) {
                      if (window.init) {
                        this.pauseAllVideos();
                      }
                      window.init = true;
                    }
                },
            },
            breakpoints: { 500: { slidesPerView: 3 }, 1024: { slidesPerView: 4 }, 1360: { slidesPerView: 5,centeredSlides: false } },
        };
        this.swiperInstance = new Swiper(this.element, oldOptions);
        
        // Initialize sequential video playback
        this.initSequentialPlayback();
    }

    // Initialize sequential video playback
    initSequentialPlayback() {
        // Get all video elements
        this.videos = this.element.querySelectorAll('video');
        if (this.videos.length === 0) return;
        
        // Add event listeners to all videos
        this.videos.forEach((video, index) => {
            video.addEventListener('ended', () => {
                this.playNextVideo(index);
            });
            
            // Add loadedmetadata event to ensure video is ready
            // video.addEventListener('loadedmetadata', () => {
            //     if (index === 0) {
            //         // Start playing the first video after a short delay
            //         setTimeout(() => {
            //             this.playVideo(0);
            //         }, 1000);
            //     }
            // });
        });
        this.playVideo(0);
    }

    // Play video at specific index
    playVideo(index) {
        if (index >= 0 && index < this.videos.length) {
            // Pause all videos first
            this.pauseAllVideos();
            
            // Play the specified video
            const video = this.videos[index];
            video.currentTime = 0; // Reset to beginning

            this.currentVideoIndex = index;
            
            // Update swiper to show the current video
            if (this.swiperInstance) {
                this.swiperInstance.slideTo(index);
            }

            video.nextElementSibling.dispatchEvent(new Event('click'));
        }
    }

    // Play next video in sequence
    playNextVideo(currentIndex) {
        const nextIndex = (currentIndex + 1) % this.videos.length;
        this.playVideo(nextIndex);
    }

    // Method to pause all videos except the active one
    pauseAllVideos() {
        const videos = this.element.querySelectorAll('video'); // Select all video elements
        const activeIndex = this.swiperInstance.realIndex; // Get the active slide index
        videos.forEach((video, index) => {
            // Pause all other videos
            video.pause();
        });
    }
}
customElements.define("swiper-slider", SwiperSlider);

setTimeout(function() {
  if (document.querySelectorAll('.five-senses-carousel__video').length > 0) {
    if (document.querySelector('.five-senses-carousel__video').paused) {
        document.querySelector('.five-senses-carousel__video').play();
    }
  }
},500);

setTimeout(() => {
    
$(".five-senses-carousel__slide video-player .ctm_mute_btn").click(function(){
    console.log("this", this)
    if($(this).hasClass("active")){
        $(this).removeClass("active");
        $(this).parents(".five-senses-carousel__slide").find("video").prop('muted', true);
    } else
    {
        $(this).addClass("active");
        $(this).parents(".five-senses-carousel__slide").find("video").prop('muted', false);
        $(this).parents(".five-senses-carousel__slide").siblings().find(".ctm_mute_btn").removeClass("active");
        $(this).parents(".five-senses-carousel__slide").siblings().find("video").prop('muted', true);
    }
});
}, 1000);

var hasIngredient = false;
$('.ingredients-glossary').each(function(index, glossary){
    var ingredients_list = $(this).parents('.section').find('.ingredients__table > li').length;
    if (ingredients_list > 1) {
        hasIngredient = true;
    }
});
if ($('body').hasClass('product-template') && !hasIngredient) {
    $('[js-ingredients="link-wrapper"]').hide();
}

if (typeof Swiper == 'function') {
    var swiper = new Swiper('.review-ticker-slider', {
        slidesPerView: 'auto',
        spaceBetween:0,
        speed: 3000,
        grabCursor: true,
        autoplay: {
        delay: 1,
        },
        loop: true,
        observer: true,
        freeMode: false,  
        observeParents: true,
        navigation: {
        nextEl:'.swiper-button-next',
        prevEl: '.swiper-button-prev',
        },
        pagination: {
        el: '.slider__pagination',
        clickable: true,
        }, 
        keyboard: {
        enabled: true,
        },
    });
}


$('a[href^="#"]').on('click', function (e) {
  var target = $(this).attr("href");
  if (target !== "#" && $(target).length) {
    e.preventDefault();
    $('html, body').animate(
      { 
        scrollTop: $(target).offset().top - 70
      },
      600
    );
  }
});

$(document).ready(function() {
    var swiper = new Swiper(".template-article__swipe-container", {
    slidesPerView: 2,
    direction: "vertical",
    spaceBetween: 30,
    mousewheel: true,
    navigation: {
        nextEl: ".template-article__swiper-next",
        prevEl: ".template-article__swiper-prev",
    },
    });
});